import { useQuery } from "@tanstack/react-query";
import { fetchPublicConfig, type PublicConfig } from "@api/publicConfig";

export const usePublicConfig = () => {
  return useQuery<PublicConfig>({
    queryKey: ["publicConfig"],
    queryFn: fetchPublicConfig,
    staleTime: Infinity,
  });
};
